import { FC } from "react"
import { SubscriptionDetails } from "../../../../../../../types"
import {
  CurrencyValueCell,
  OptionValueToNameCell,
  SectionCell
} from "../../../../../section"
import If from "../../../../../if"

interface Props {
  quote_info: SubscriptionDetails["quote_info"]
}

const LoanScenario: FC<Props> = ({
  quote_info: {
    loan_amount,
    loan_purpose,
    loan_type,
    loan_term,
    arm_term,
    property_type,
    list_price,
    property_value,
    residency_type,
    credit_score,
    household_income,
    va_funding_fee_type
  }
}) => (
  <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
    <OptionValueToNameCell label="Loan purpose" value={loan_purpose} />

    <OptionValueToNameCell label="Loan type" value={loan_type} />

    <If
      condition={loan_type === "arm"}
      then={<OptionValueToNameCell label="Arm term" value={arm_term ?? 0} />}
      else={<OptionValueToNameCell label="Loan term" value={loan_term ?? 0} />}
    />

    <CurrencyValueCell label="Loan amount" value={loan_amount} />
    <CurrencyValueCell
      label="Property value"
      value={list_price || property_value || 0}
    />

    <If
      condition={!!household_income}
      then={
        <CurrencyValueCell
          label="Household income"
          value={household_income ?? 0}
        />
      }
    />

    <SectionCell label="Credit score" value={credit_score} className="!pt-0" />
    <OptionValueToNameCell label="Property type" value={property_type} />
    <OptionValueToNameCell label="Property usage" value={residency_type} />
    <If
      condition={loan_type === "va"}
      then={
        <OptionValueToNameCell
          label="VA Funding Fee"
          value={va_funding_fee_type ?? ""}
        />
      }
    />
  </div>
)

export default LoanScenario
